import React from "react";
import { Fade } from "react-reveal";
import { team } from "../../portfolio";
import "./Team.css";

export default function Team(props) {
  const theme = props.theme;

  return (
    <div className="team-main motion-team-section" id="team">
      <section className="team-intro-section" aria-label="ZENTO 소개">
        <Fade bottom duration={1600} distance="30px">
          <div className="team-manifesto-hero">
            <div className="team-intro-copy">
              <p className="team-intro-eyebrow">ZENTO Manifesto</p>
              <h1 className="team-intro-title" style={{ color: theme.text }}>
                {team.intro.title}
              </h1>
              <p className="team-intro-description" style={{ color: theme.secondaryText }}>
                {team.intro.description}
              </p>
            </div>
            <div className="team-manifesto-image-panel" aria-hidden="true">
              <img
                className="team-manifesto-image"
                src="/media/showcase/gallery-image-01.jpg"
                alt=""
              />
            </div>
          </div>
        </Fade>

        <div className="team-manifesto-list">
          {team.intro.principles.map((principle, index) => (
            <Fade bottom duration={1400} distance="26px" delay={index * 120} key={principle.label}>
              <article className="team-principle-row">
                <div className="team-principle-marker" aria-hidden="true">
                  <span className="team-principle-number">{String(index + 1).padStart(2, "0")}</span>
                  <span className="team-principle-line" />
                </div>
                <div className="team-principle-content">
                  <span className="team-principle-label">{principle.label}</span>
                  <h2 className="team-principle-title" style={{ color: theme.text }}>
                    {principle.title}
                  </h2>
                  <p className="team-principle-body" style={{ color: theme.secondaryText }}>
                    {principle.body}
                  </p>
                </div>
              </article>
            </Fade>
          ))}
        </div>
      </section>

      <div className="team-header-div">
        <Fade bottom duration={2000} distance="20px">
          <h1 className="team-header" style={{ color: theme.text }}>
            {team.title}
          </h1>
          <p className="team-subtitle subTitle" style={{ color: theme.secondaryText }}>
            {team.subtitle}
          </p>
        </Fade>
      </div>

      <div className="team-card-list">
        {team.members.map((member) => (
          <div className="team-card-row" key={member.name}>
            <Fade left duration={1800} distance="30px">
              <div className="team-image-div">
                <img
                  src={require(`../../assets/images/team/${member.image}`)}
                  alt={`${member.name} portrait`}
                />
              </div>
            </Fade>

            <Fade right duration={1800} distance="30px">
              <div className="team-text-div">
                <div className="team-name-line">
                  <h2 className="team-name" style={{ color: theme.text }}>
                    {member.name}
                  </h2>
                </div>
                <h3
                  className={`team-focus${member.focusOutline ? " team-focus-outline" : ""}${
                    member.darkFocusOutline ? " team-focus-dark-outline" : ""
                  }`}
                  style={{
                    color: member.focusColor || theme.text,
                  }}
                >
                  {member.focus}
                </h3>
                <p className="team-bio subTitle" style={{ color: theme.secondaryText }}>
                  {member.bio}
                </p>
                {member.history && (
                  <ul className="team-history-list">
                    {member.history.map((item) => (
                      <li className="team-history-item" key={item.label}>
                        <span
                          className={`team-history-label${
                            member.darkFocusOutline ? " team-history-label-outline" : ""
                          }`}
                          style={{ color: member.focusColor || theme.text }}
                        >
                          {item.label}
                        </span>
                        <span className="team-history-body" style={{ color: theme.secondaryText }}>
                          {item.body}
                        </span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </Fade>
          </div>
        ))}
      </div>
    </div>
  );
}
